import { FooterTheme } from '@components/footer/enum';
import { FooterStyle } from '@components/footer/model';

export const footerStyle: { [key: string]: FooterStyle } = {
  [FooterTheme.BLUE]: {
    backgroundColor: 'BLUE',
    textColor: 'WHITE',
    socialNetworksStyle: 'BLUE',
  },
  [FooterTheme.RED]: {
    backgroundColor: 'RED',
    textColor: 'WHITE',
    socialNetworksStyle: 'RED',
  },
  [FooterTheme.OPAL]: {
    backgroundColor: 'OPAL',
    textColor: 'BLACK',
    socialNetworksStyle: 'TRANSPARENT_BLACK',
  },
};
